module.exports = __webpack_public_path__ + "85b31041dda0f24b0509e137e1725072.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/downloadSite/images/dl-widget-bg-image.png
// module id = 115
// module chunks = 0